import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=51165c60&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51165c60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51165c60')) {
      api.createRecord('51165c60', component.options)
    } else {
      api.reload('51165c60', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=51165c60&scoped=true&", function () {
      api.rerender('51165c60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-203ngpnSk8sy9/JS/comp/SearchFilterTokens.vue"
export default component.exports